import { PractitionerView } from '@dreryk/egabinet-personnel-frontend-api';

import {
   createInterpolatedTranslationKey,
   createTranslatedText,
   practitionerNameFormatter,
   TranslateFunction,
} from '@dreryk/react-common';
import {
   FilterPanelControllerCodecConfigArray,
   FilterPanelControllerDeselectorsPropsMapper,
} from '@dreryk/react-components';

import { translationKeys } from '../../../translations';
import { GroupSessionsFilterPanelSearchParam } from '../../GroupSessionsFilterPanel.types';

export const createPractitionersTriggerLabelExtractor = (
   totalCount: number,
   translate: TranslateFunction
): ((chosenPractitioners: PractitionerView[]) => string) => {
   return (chosenPractitioners) => {
      if (chosenPractitioners.length === 1) {
         return practitionerNameFormatter(chosenPractitioners.at(0)!)!;
      }
      const translationKey = createInterpolatedTranslationKey(translationKeys.chosenOptions, {
         count: chosenPractitioners.length,
         totalCount: totalCount,
      });
      return translate(translationKey);
   };
};

export const createPractitionersCodec = (
   practitioners: PractitionerView[]
): FilterPanelControllerCodecConfigArray<PractitionerView> => ({
   type: 'array',
   items: practitioners,
   keyGenerator: (practitioner) => practitioner.id,
});

export const practitionersDeselectorsPropsMapper: FilterPanelControllerDeselectorsPropsMapper<
   PractitionerView[],
   GroupSessionsFilterPanelSearchParam.PRACTITIONER
> = (currentPractitioners) => {
   return currentPractitioners.map((practitioner) => ({
      targetValue: currentPractitioners.filter((currentPractitioner) => currentPractitioner.id !== practitioner.id),
      label: createTranslatedText(practitionerNameFormatter(practitioner)),
      testId: `practitioner-${practitioner.id}`,
   }));
};
